// import React, { useEffect, useState } from "react";
// import Image1 from "../Assets/BalanceImageCarousel/image1.jpeg";
// import Image2 from "../Assets/BalanceImageCarousel/image2.jpeg";
// import Image3 from "../Assets/BalanceImageCarousel/image3.jpeg";
// import Image4 from "../Assets/BalanceImageCarousel/image4.jpeg";

// const BalanceCarousel = () => {
//   const images = [Image1, Image2, Image3, Image4];
//   const [currentSlide, setCurrentSlide] = useState(0);
//   const [fade, setFade] = useState(true);

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setFade(false);

//       setTimeout(() => {
//         setCurrentSlide((prev) => (prev + 1) % images.length);
//         setFade(true);
//       }, 500);
//     }, 6000);

//     return () => clearInterval(interval);
//   }, []);

// return (
//   <div
//     className="w-full 
//                h-[380px] sm:h-[420px] md:h-[520px] lg:h-[620px] 
//                mb-6 lg:mb-12 
//                relative overflow-hidden 
//                rounded-2xl lg:rounded-l-[40px] lg:rounded-r-none"
//   >

//     <img
//       src={images[currentSlide]}
//       alt="carousel"
//       className={`w-full h-full object-cover object-center absolute 
//       transition-opacity duration-700 ease-in-out 
//       ${fade ? "opacity-100" : "opacity-0"}`}
//     />

//   </div>
// );


// };

// export default BalanceCarousel;


import React, { useEffect, useState } from "react";
import Image1 from "../Assets/BalanceImageCarousel/image5.PNG";
import Image2 from "../Assets/BalanceImageCarousel/image6.jpg";
import Image3 from "../Assets/BalanceImageCarousel/image7.jpg";
import Image4 from "../Assets/BalanceImageCarousel/image8.jpg";
import Image5 from "../Assets/BalanceImageCarousel/image9.jpg";
import Image6 from "../Assets/BalanceImageCarousel/image10.jpg";
// import Image4 from "../Assets/BalanceImageCarousel/image4.jpeg";

const BalanceCarousel = () => {
  const images = [Image1, Image2, Image3,Image4, Image5, Image6];
  const [currentSlide, setCurrentSlide] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);

      setTimeout(() => {
        setCurrentSlide((prev) => (prev + 1) % images.length);
        setFade(true);
      }, 500);
    }, 6000);

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div
      className="w-full 
                 aspect-[16/9] 
                 sm:h-[420px] md:h-[520px] lg:h-[620px]
                 mb-6 lg:mb-12 
                 relative overflow-hidden 
                 rounded-2xl lg:rounded-l-[40px] lg:rounded-r-none
                 bg-black"
    >
      <img
        src={images[currentSlide]}
        alt="carousel"
        className={`w-full h-full absolute 
                    object-contain sm:object-cover
                    transition-opacity duration-700 ease-in-out
                    ${fade ? "opacity-100" : "opacity-0"}`}
      />
    </div>
  );
};

export default BalanceCarousel;
